import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Header extends Component {
    render() {
        return (
            <section id="home" className="section welcome-area d-flex align-items-center position-relative">
                {/* Botón Login */}
                <div
                    className="position-absolute"
                    style={{
                        right: '20px',
                    }}
                >
                    <a
                        href="https://app.proyectoshark.com"
                        className="text-white px-4 py-2 d-inline-flex align-items-center"
                        style={{
                            backgroundColor: '#111e32',
                            borderRadius: '999px',
                            textDecoration: 'none',
                            fontWeight: '500'
                        }}
                    >
                        <i className="bi bi-person-fill"></i>
                        <span className="d-none d-md-inline ms-2">&nbsp;LOGIN</span>
                    </a>
                </div>

                {/* Banner o logo */}
                <Link to="/">
                    <img src="/img/BANNER.png" alt="" />
                </Link>
            </section>
        );
    }
}

export default Header;
